/**

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);

 * Bootstrap Manager - Phase 8 Migration
 * Управляет Bootstrap компонентами (tabs, tooltips, modals, etc.)
 */


/**
 * Bootstrap Manager Class
 * Управляет всеми Bootstrap компонентами приложения
 */
class BootstrapManager {
    constructor() {
        this.initialized = false;
        this.components = new Map();
        this.tabTriggers = new Map();
        this.tooltips = new Map();
        
        // Manager initialization logging only in debug mode
    }
    
    /**
     * Инициализация всех Bootstrap компонентов
     */
    async initialize() {
        if (this.initialized) {
            return true;
        }
        
        try {
            // CRITICAL: Wait for Bootstrap to be available (especially in bundled mode)
            let retries = 0;
            const maxRetries = 50; // 5 seconds max wait (50 * 100ms)
            while ((typeof bootstrap === 'undefined' || !bootstrap.Dropdown) && retries < maxRetries) {
                await new Promise(resolve => setTimeout(resolve, 100));
                retries++;
            }
            
            if (typeof bootstrap === 'undefined' || !bootstrap.Dropdown) {
                if (debugMode === '1') {
                    console.error('[BootstrapManager] Bootstrap not available after waiting');
                }
                return false;
            }
            
            // Initialize tabs
            await this.initializeBootstrapTabs();
            
            // Initialize tooltips
            await this.initializeTooltips();
            
            // Initialize modals
            await this.initializeModals();
            
            // Initialize other components
            await this.initializeOtherComponents();
            
            this.initialized = true;
            
            return true;
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Failed to initialize Bootstrap components:', error);
            }
            return false;
        }
    }
    
    /**
     * Инициализация Bootstrap табов
     * Мигрировано из main.js Bootstrap tabs logic
     */
    async initializeBootstrapTabs() {
        try {
            // Find all tab triggers
            const triggerTabList = document.querySelectorAll('#nav-tab button, [data-bs-toggle="tab"]');
            
            if (triggerTabList.length === 0) {
                if (debugMode === '1') {
                console.warn('[BootstrapManager] No tab triggers found');
            }
                return;
            }
            
            // Initialize each tab trigger
            triggerTabList.forEach((triggerEl, index) => {
                try {
                    // Create Bootstrap Tab instance
                    const tabTrigger = new bootstrap.Tab(triggerEl);
                    this.tabTriggers.set(`tab-${index}`, tabTrigger);
                    
                    // Add click event listener
                    triggerEl.addEventListener('click', (event) => {
                        this.handleTabClick(event, tabTrigger);
                    });
                    
                    // Add shown event listener
                    triggerEl.addEventListener('shown.bs.tab', (event) => {
                        this.handleTabShown(event);
                    });
                    
                } catch (error) {
                    if (debugMode === '1') {
                console.error(`[BootstrapManager] Failed to initialize tab trigger ${index}:`, error);
            }
                }
            });
            
            // Handle URL hash for initial tab activation
            await this.handleInitialTabActivation();
            
            if (debugMode === '1') {
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Failed to initialize Bootstrap tabs:', error);
            }
            throw error;
        }
    }
    
    /**
     * Обработка первоначальной активации таба на основе URL
     */
    async handleInitialTabActivation() {
        try {
            const currentUrl = window.location.href;
            const tabMatch = currentUrl.match(/#([a-z]+)/);
            
            if (tabMatch && tabMatch[1]) {
                const tab = tabMatch[1];
                const triggerEl = document.querySelector(`#nav-tab button[tab-link="${tab}"]`);
                
                if (triggerEl) {
                    const tabInstance = new bootstrap.Tab(triggerEl);
                    tabInstance.show();
                    
                    if (debugMode === '1') {
                console.log(`[BootstrapManager] Activated tab from URL: ${tab}`);
            }
                } else {
                    if (debugMode === '1') {
                console.warn(`[BootstrapManager] Tab trigger not found for: ${tab}`);
            }
                }
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Failed to handle initial tab activation:', error);
            }
        }
    }
    
    /**
     * Обработчик клика по табу
     */
    handleTabClick(event, tabTrigger) {
        try {
            const targetButton = $(event.target).closest("button");
            const tabLink = targetButton.attr('tab-link');
            
            if (tabLink) {
                // Update URL hash
                const newUrl = `${window.location.pathname}${window.location.search}#${tabLink}`;
                window.history.pushState(null, null, newUrl);
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Tab click handler error:', error);
            }
        }
    }
    
    /**
     * Обработчик показа таба
     */
    handleTabShown(event) {
        try {
            const shownTab = event.target;
            const tabId = shownTab.getAttribute('id');
            const tabLink = shownTab.getAttribute('tab-link');
            
            // Trigger custom events for tab activation
            $(document).trigger('tab:shown', {
                tabId,
                tabLink,
                element: shownTab
            });

            // Manage sticky search-line: disable sticky for fulltext tab, enable for files tab
            try {
                const searchLine = document.querySelector('.search-line');
                if (searchLine) {
                    if (tabLink === 'fulltext') {
                        searchLine.classList.add('fulltext-active');
                    } else {
                        searchLine.classList.remove('fulltext-active');
                    }
                }
            } catch(_) { /* noop */ }

            // Trigger wave animation when switching to Content tab
            try {
                if (tabLink === 'fulltext') {
                    const nav = document.getElementById('nav-tab');
                    if (nav) {
                        nav.classList.remove('wave-activate');
                        // Force reflow to restart animation reliably
                        void nav.offsetWidth;
                        nav.classList.add('wave-activate');
                        setTimeout(() => nav.classList.remove('wave-activate'), 2000);
                    }
                }
            } catch(_) { /* noop */ }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Tab shown handler error:', error);
            }
        }
    }
    
    /**
     * Инициализация Bootstrap tooltips
     * Мигрировано из main.js tooltip initialization
     */
    async initializeTooltips() {
        try {
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            
            if (tooltipTriggerList.length === 0) {
                if (debugMode === '1') {
            }
                return;
            }
            
            // Initialize each tooltip
            const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl, index) => {
                try {
                    const tooltip = new bootstrap.Tooltip(tooltipTriggerEl);
                    this.tooltips.set(`tooltip-${index}`, tooltip);
                    return tooltip;
                } catch (error) {
                    if (debugMode === '1') {
                console.error(`[BootstrapManager] Failed to initialize tooltip ${index}:`, error);
            }
                    return null;
                }
            }).filter(tooltip => tooltip !== null);
            
            if (debugMode === '1') {
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Failed to initialize tooltips:', error);
            }
            throw error;
        }
    }
    
    /**
     * Инициализация Bootstrap modals
     */
    async initializeModals() {
        try {
            const modalElements = document.querySelectorAll('.modal');
            
            if (modalElements.length === 0) {
                if (debugMode === '1') {
            }
                return;
            }
            
            modalElements.forEach((modalEl, index) => {
                try {
                    const modal = new bootstrap.Modal(modalEl);
                    this.components.set(`modal-${index}`, modal);
                    
                    // Add event listeners
                    modalEl.addEventListener('shown.bs.modal', (event) => {
                        this.handleModalShown(event);
                    });
                    
                    modalEl.addEventListener('hidden.bs.modal', (event) => {
                        this.handleModalHidden(event);
                    });
                    
                } catch (error) {
                    if (debugMode === '1') {
                console.error(`[BootstrapManager] Failed to initialize modal ${index}:`, error);
            }
                }
            });
            
            if (debugMode === '1') {
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Failed to initialize modals:', error);
            }
            throw error;
        }
    }
    
    /**
     * Инициализация других Bootstrap компонентов
     */
    async initializeOtherComponents() {
        try {
            // Initialize dropdowns
            await this.initializeDropdowns();
            
            // Initialize popovers
            await this.initializePopovers();
            
            // Initialize collapses
            await this.initializeCollapses();
            
            if (debugMode === '1') {
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Failed to initialize other components:', error);
            }
            throw error;
        }
    }
    
    /**
     * Инициализация Bootstrap dropdowns
     */
    async initializeDropdowns() {
        try {
            // CRITICAL: Ensure Bootstrap is available
            if (typeof bootstrap === 'undefined' || !bootstrap.Dropdown) {
                if (debugMode === '1') {
                    console.warn('[BootstrapManager] Bootstrap not available for dropdowns initialization');
                }
                return;
            }
            
            const dropdownElements = document.querySelectorAll('[data-bs-toggle="dropdown"]');
            
            if (debugMode === '1') {
                console.log(`[BootstrapManager] Found ${dropdownElements.length} dropdown elements to initialize`);
                dropdownElements.forEach((el, idx) => {
                    console.log(`[BootstrapManager] Dropdown ${idx}: id="${el.id}", classes="${el.className}"`);
                });
            }
            
            dropdownElements.forEach((dropdownEl, index) => {
                try {
                    // Check if already initialized
                    const existingInstance = bootstrap.Dropdown.getInstance(dropdownEl);
                    if (existingInstance) {
                        if (debugMode === '1') {
                            console.log(`[BootstrapManager] Dropdown ${index} (id="${dropdownEl.id}") already initialized, reusing instance`);
                        }
                        this.components.set(`dropdown-${index}`, existingInstance);
                        return;
                    }
                    
                    const dropdown = new bootstrap.Dropdown(dropdownEl);
                    this.components.set(`dropdown-${index}`, dropdown);
                    
                    // CRITICAL FIX: Prevent preventDefault() from blocking Bootstrap dropdown in bundled mode
                    if (dropdownEl.id === 'date-range-toggle') {
                        // Add handler on window in capture phase - runs EARLIEST possible
                        // This must run before ANY other handlers to prevent preventDefault()
                        const earliestHandler = function(e) {
                            const clickTarget = e.target;
                            const isDateRangeToggle = clickTarget === dropdownEl || 
                                                      (dropdownEl.contains && dropdownEl.contains(clickTarget));
                            
                            if (isDateRangeToggle) {
                                // Mark event IMMEDIATELY to prevent other handlers from calling preventDefault()
                                e._dateRangeToggleClick = true;
                                e._allowBootstrapDefault = true;
                                
                                if (debugMode === '1') {
                                    console.log('[BootstrapManager] 🔍 date-range-toggle click (window capture, EARLIEST):', {
                                        target: clickTarget,
                                        defaultPrevented: e.defaultPrevented,
                                        timeStamp: e.timeStamp
                                    });
                                }
                            }
                        };
                        
                        // Add to window in capture phase (runs EARLIEST, before document handlers)
                        window.addEventListener('click', earliestHandler, true);
                        
                        // Also add to document as backup
                        document.addEventListener('click', function(e) {
                            const clickTarget = e.target;
                            const isDateRangeToggle = clickTarget === dropdownEl || 
                                                      (dropdownEl.contains && dropdownEl.contains(clickTarget));
                            
                            if (isDateRangeToggle) {
                                // Mark event if not already marked
                                if (!e._dateRangeToggleClick) {
                                    e._dateRangeToggleClick = true;
                                    e._allowBootstrapDefault = true;
                                }
                                
                                if (debugMode === '1') {
                                    console.log('[BootstrapManager] 🔍 date-range-toggle click (document capture):', {
                                        target: clickTarget,
                                        defaultPrevented: e.defaultPrevented,
                                        timeStamp: e.timeStamp
                                    });
                                }
                            }
                        }, true);
                        
                        // CRITICAL: Prevent immediate closing after opening (like language dropdown fix)
                        // But allow closing if user clicks toggle button again (normal Bootstrap behavior)
                        let showTime = 0;
                        let hideTime = 0;
                        let lastClickTarget = null;
                        let lastClickTime = 0;
                        
                        // Track clicks to determine if hide was triggered by toggle button click
                        dropdownEl.addEventListener('click', function(e) {
                            lastClickTarget = e.target;
                            lastClickTime = Date.now();
                            if (debugMode === '1') {
                                console.log('[BootstrapManager] 🔍 date-range-toggle click tracked:', {
                                    target: e.target,
                                    time: lastClickTime
                                });
                            }
                        }, true); // Capture phase to catch early
                        
                        dropdownEl.addEventListener('show.bs.dropdown', function(e) {
                            const timeSinceHide = hideTime > 0 ? Date.now() - hideTime : Infinity;
                            
                            // CRITICAL: Prevent immediate reopening after closing (< 100ms)
                            // This prevents dropdown from reopening immediately after user closes it
                            if (timeSinceHide < 100) {
                                if (debugMode === '1') {
                                    console.warn('[BootstrapManager] ⚠️ Preventing immediate reopen (too fast after hide:', timeSinceHide, 'ms)');
                                }
                                e.preventDefault();
                                e.stopPropagation();
                                return false;
                            }
                            
                            // CRITICAL: Always update showTime when dropdown opens
                            // This ensures we track the correct time for each open/close cycle
                            showTime = Date.now();
                            if (debugMode === '1') {
                                console.log('[BootstrapManager] 🔍 show.bs.dropdown:', {
                                    showTime: showTime,
                                    timeSinceHide: timeSinceHide,
                                    event: e
                                });
                            }
                        });
                        
                        dropdownEl.addEventListener('shown.bs.dropdown', function(e) {
                            if (debugMode === '1') {
                                console.log('[BootstrapManager] 🔍 shown.bs.dropdown:', e);
                            }
                        });
                        
                        dropdownEl.addEventListener('hidden.bs.dropdown', function(e) {
                            hideTime = Date.now();
                            if (debugMode === '1') {
                                console.log('[BootstrapManager] 🔍 hidden.bs.dropdown:', {
                                    hideTime: hideTime,
                                    event: e
                                });
                            }
                        });
                        
                        dropdownEl.addEventListener('hide.bs.dropdown', function(e) {
                            const timeSinceShow = Date.now() - showTime;
                            const timeSinceLastClick = Date.now() - lastClickTime;
                            const clickEvent = e.clickEvent;
                            
                            // Try multiple ways to determine if click was on toggle button
                            let clickTarget = null;
                            if (clickEvent && clickEvent.target) {
                                clickTarget = clickEvent.target;
                            } else if (lastClickTarget && timeSinceLastClick < 200) {
                                // Use lastClickTarget if click was recent (< 200ms)
                                clickTarget = lastClickTarget;
                            } else if (e.relatedTarget) {
                                // Sometimes relatedTarget contains the click target
                                clickTarget = e.relatedTarget;
                            }
                            
                            // Check if click was on the toggle button itself or its children
                            const isToggleClick = clickTarget && (
                                clickTarget === dropdownEl || 
                                (dropdownEl.contains && dropdownEl.contains(clickTarget))
                            );
                            
                            // Check if dropdown was just shown (< 50ms) - reduced threshold for faster toggle
                            const wasJustShown = timeSinceShow >= 0 && timeSinceShow < 50;
                            
                            if (debugMode === '1') {
                                console.log('[BootstrapManager] 🔍 hide.bs.dropdown:', {
                                    timeSinceShow: timeSinceShow,
                                    timeSinceLastClick: timeSinceLastClick,
                                    isToggleClick: isToggleClick,
                                    wasJustShown: wasJustShown,
                                    clickTarget: clickTarget,
                                    lastClickTarget: lastClickTarget,
                                    clickEvent: clickEvent,
                                    relatedTarget: e.relatedTarget
                                });
                            }
                            
                            // CRITICAL: Prevent immediate closing (< 50ms after show) if dropdown was just shown
                            // This prevents accidental/immediate close after opening
                            // Exception: If enough time passed (>= 50ms), allow closing (normal toggle behavior)
                            // The key: when user clicks toggle button to OPEN dropdown, it should stay open
                            // When user clicks toggle button again AFTER dropdown was open for a while, it should close
                            if (wasJustShown) {
                                if (debugMode === '1') {
                                    console.warn('[BootstrapManager] ⚠️ Preventing immediate hide (too fast after show:', timeSinceShow, 'ms)');
                                }
                                e.preventDefault();
                                e.stopPropagation();
                                return false;
                            }
                            
                            // Allow closing if enough time has passed (normal behavior - user wants to close)
                            if (timeSinceShow >= 50 && debugMode === '1') {
                                console.log('[BootstrapManager] ✅ Allowing hide (enough time passed:', timeSinceShow, 'ms)');
                            }
                        });
                    }
                    
                    if (debugMode === '1') {
                        console.log(`[BootstrapManager] ✅ Initialized dropdown ${index}: id="${dropdownEl.id || 'no-id'}", element:`, dropdownEl);
                    }
                } catch (error) {
                    if (debugMode === '1') {
                        console.error(`[BootstrapManager] ❌ Failed to initialize dropdown ${index} (id="${dropdownEl.id || 'no-id'}"):`, error);
                    }
                }
            });
            
            if (dropdownElements.length > 0) {
                if (debugMode === '1') {
                    console.log(`[BootstrapManager] ✅ Initialized ${dropdownElements.length} dropdowns total`);
                }
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Failed to initialize dropdowns:', error);
            }
        }
    }
    
    /**
     * Инициализация Bootstrap popovers
     */
    async initializePopovers() {
        try {
            const popoverElements = document.querySelectorAll('[data-bs-toggle="popover"]');
            
            popoverElements.forEach((popoverEl, index) => {
                try {
                    const popover = new bootstrap.Popover(popoverEl);
                    this.components.set(`popover-${index}`, popover);
                } catch (error) {
                    if (debugMode === '1') {
                console.error(`[BootstrapManager] Failed to initialize popover ${index}:`, error);
            }
                }
            });
            
            if (popoverElements.length > 0) {
                if (debugMode === '1') {
                console.log(`[BootstrapManager] ${popoverElements.length} popovers initialized`);
            }
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Failed to initialize popovers:', error);
            }
        }
    }
    
    /**
     * Инициализация Bootstrap collapses
     */
    async initializeCollapses() {
        try {
            const collapseElements = document.querySelectorAll('[data-bs-toggle="collapse"]');
            
            collapseElements.forEach((collapseEl, index) => {
                try {
                    const collapse = new bootstrap.Collapse(collapseEl);
                    this.components.set(`collapse-${index}`, collapse);
                } catch (error) {
                    if (debugMode === '1') {
                console.error(`[BootstrapManager] Failed to initialize collapse ${index}:`, error);
            }
                }
            });
            
            if (collapseElements.length > 0) {
                if (debugMode === '1') {
                console.log(`[BootstrapManager] ${collapseElements.length} collapses initialized`);
            }
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Failed to initialize collapses:', error);
            }
        }
    }
    
    /**
     * Обработчик показа модального окна
     */
    handleModalShown(event) {
        try {
            const modal = event.target;
            const modalId = modal.getAttribute('id');
            
            // Trigger custom event
            $(document).trigger('modal:shown', {
                modalId,
                element: modal
            });
            
            if (window.HyperLog) {
                window.HyperLog.debug('[BootstrapManager] Modal shown:', { modalId });
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Modal shown handler error:', error);
            }
        }
    }
    
    /**
     * Обработчик скрытия модального окна
     */
    handleModalHidden(event) {
        try {
            const modal = event.target;
            const modalId = modal.getAttribute('id');
            
            // Trigger custom event
            $(document).trigger('modal:hidden', {
                modalId,
                element: modal
            });
            
            if (window.HyperLog) {
                window.HyperLog.debug('[BootstrapManager] Modal hidden:', { modalId });
            }
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[BootstrapManager] Modal hidden handler error:', error);
            }
        }
    }
    
    /**
     * Получение компонента по ID
     */
    getComponent(componentId) {
        return this.components.get(componentId);
    }
    
    /**
     * Показать модальное окно по ID
     */
    showModal(modalId) {
        try {
            const modalElement = document.getElementById(modalId);
            if (modalElement) {
                const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
                modal.show();
                return true;
            }
            return false;
        } catch (error) {
            if (debugMode === '1') {
                console.error(`[BootstrapManager] Failed to show modal ${modalId}:`, error);
            }
            return false;
        }
    }
    
    /**
     * Скрыть модальное окно по ID
     */
    hideModal(modalId) {
        try {
            const modalElement = document.getElementById(modalId);
            if (modalElement) {
                const modal = bootstrap.Modal.getOrCreateInstance(modalElement);
                modal.hide();
                return true;
            }
            return false;
        } catch (error) {
            if (debugMode === '1') {
                console.error(`[BootstrapManager] Failed to hide modal ${modalId}:`, error);
            }
            return false;
        }
    }
    
    /**
     * Активировать таб по ID
     */
    activateTab(tabId) {
        try {
            const tabElement = document.getElementById(tabId);
            if (tabElement) {
                const tab = new bootstrap.Tab(tabElement);
                tab.show();
                return true;
            }
            return false;
        } catch (error) {
            if (debugMode === '1') {
                console.error(`[BootstrapManager] Failed to activate tab ${tabId}:`, error);
            }
            return false;
        }
    }
    
    /**
     * Получение статистики Bootstrap компонентов
     */
    getComponentStats() {
        return {
            initialized: this.initialized,
            totalComponents: this.components.size,
            totalTabs: this.tabTriggers.size,
            totalTooltips: this.tooltips.size,
            componentTypes: {
                tabs: Array.from(this.tabTriggers.keys()).length,
                tooltips: Array.from(this.tooltips.keys()).length,
                modals: Array.from(this.components.keys()).filter(k => k.startsWith('modal-')).length,
                dropdowns: Array.from(this.components.keys()).filter(k => k.startsWith('dropdown-')).length,
                popovers: Array.from(this.components.keys()).filter(k => k.startsWith('popover-')).length,
                collapses: Array.from(this.components.keys()).filter(k => k.startsWith('collapse-')).length
            }
        };
    }
}

// Создаем singleton instance
const bootstrapManager = new BootstrapManager();

// Global exports для backward compatibility
window.bootstrapManager = bootstrapManager;
window.initializeBootstrapTabs = bootstrapManager.initializeBootstrapTabs.bind(bootstrapManager);

// ES Module exports
export { bootstrapManager };
export const { initializeBootstrapTabs } = bootstrapManager; 